import { SET_LOCALE, EN_LOCALE } from '../actions/i18n';

const INITIAL_STATE = {
    locale: EN_LOCALE,
};

const i18nReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_LOCALE:
            return {
                ...state,
                locale: action.payload,
            };
        default:
            return state;
    }
};

export default i18nReducer;
